import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import momentUtils from '@/common/moment-utils'
import '../src/assets/theme/default/style.scss'
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import Select2 from 'vue3-select2-component'
import 'select2/dist/js/i18n/ru';

const app = createApp(App).use(store).use(router);
app.config.globalProperties.$momentFormat = (date, format) => date != null ? moment(date).format(format) : '';
app.component('Select2', Select2);
app.config.globalProperties.$moment = momentUtils;
app.mount('#app');
